var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_menu_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line Copy",
    d: "M1.97727 8.00416H22.0227",
    stroke: "#251562",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line Copy 2",
    d: "M1.97727 15.0078H22.0227",
    stroke: "#251562",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M1.97727 1.00049H22.0227",
    stroke: "#251562",
    strokeWidth: 2,
    strokeLinecap: "square"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMenu);
export default __webpack_public_path__ + "static/media/ico_menu.06fd72555ab627de77585a6a271fb236.svg";
export { ForwardRef as ReactComponent };